import BigNumber from 'bn.js'
import { createContext } from 'react'

interface StatsContextProps {
  geotokensMinted?: number
  refresh?: () => void
  totalBidders?: number
  totalBids?: number
  totalXyoBid?: BigNumber
  totalXyoBurned?: BigNumber
  totalXyoFlowed?: BigNumber
  totalXyoMintingRewards?: BigNumber
  totalXyoSpent?: BigNumber
  update?: () => void
}

export const StatsContext = createContext<StatsContextProps>({})
